export enum ForecastSourceEnum {
  AG2 = 'AG2',
  WSI = 'WSI',
  CFAN = 'CFAN',
  GFS_OP = 'GFS_OP',
  GFS_ENS = 'GFS_ENS',
  ECMWF_OP = 'ECMWF_OP',
  ECMWF_ENS = 'ECMWF_ENS',
  GEM_OP = 'GEM_OP',
  GEM_ENS = 'GEM_ENS',
  ECMWF_AIFS = 'ECMWF_AIFS',
  ECMWF_AIFS_ENS = 'ECMWF_AIFS_ENS',
  WXMK = 'WXMK',
}
